/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_Search_SuccessInputs */

const es_tools_dropbox_search_success = /** @type {(inputs: Tools_Dropbox_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda en Dropbox completada`)
};

const en_tools_dropbox_search_success = /** @type {(inputs: Tools_Dropbox_Search_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox search complete`)
};

/**
* | output |
* | --- |
* | "Dropbox search complete" |
*
* @param {Tools_Dropbox_Search_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_search_success = /** @type {((inputs?: Tools_Dropbox_Search_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_Search_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_search_success(inputs)
	return en_tools_dropbox_search_success(inputs)
});
export { tools_dropbox_search_success as "tools.dropbox.search_success" }